import React from "react";
import "../../styles/privacy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
  <header className="privacy-header">
    <h1>Privacy Policy</h1>
    <p>Your privacy is important to us. This policy explains how we collect, use, and protect your personal information in connection with our mobile applications and services.</p>
  </header>

  <section className="privacy-content">
    <h2>Apps Covered by This Policy</h2>
    <p>
      This privacy policy applies to mobile applications developed by <strong>Belivmart</strong>, including but not limited to:
    </p>
    <ul>
      <li><strong>Belivmart</strong> (Customer App – <code>com.belivmart.app</code>)</li>
      <li><strong>Partner BM</strong> (Partner Admin App – <code>com.belivmart.app.partner</code>)</li>
    </ul>

    <h2>Information We Collect</h2>
    <p>
      We collect information you provide directly, such as when you create an account, place an order, or contact customer support. This may include your name, phone number, address, payment details, and any other information you submit via our apps or website.
    </p>

    <h3>Location Information</h3>
    <p>
      Our apps may access and collect your device's location information to:
    </p>
    <ul>
      <li>Provide location-based services such as finding nearby merchants or delivery partners</li>
      <li>Enable accurate delivery address selection and verification</li>
      <li>Improve service availability and delivery accuracy</li>
      <li>Provide relevant local offers and promotions</li>
    </ul>
    <p>
      <strong>Partner BM App (com.belivmart.app.partner):</strong> This app specifically collects live location data from delivery partners to enable real-time order tracking. This location tracking is essential for:
    </p>
    <ul>
      <li>Real-time order tracking for customers</li>
      <li>Optimizing delivery routes and estimated arrival times</li>
      <li>Ensuring delivery partner safety and accountability</li>
      <li>Providing accurate delivery status updates</li>
    </ul>
    <p>
      Location access is only used when you grant permission and is essential for core app functionality. You can control location permissions through your device settings at any time.
    </p>

    <h2>How We Use Your Information</h2>
    <p>
      We use the collected information to:
    </p>
    <ul>
      <li>Process and fulfill orders</li>
      <li>Manage partner operations</li>
      <li>Provide customer and partner support</li>
      <li>Improve app functionality and services</li>
      <li>Communicate with users for service-related updates</li>
      <li>Provide location-based services and delivery optimization</li>
    </ul>

    <h2>Sharing Your Information</h2>
    <p>
      We do not sell or share your personal information with third parties, except:
    </p>
    <ul>
      <li>As required by law or regulatory authorities</li>
      <li>With service providers necessary to operate our apps (e.g., payment processors, delivery partners)</li>
      <li>Location data may be shared with delivery partners to facilitate order fulfillment</li>
    </ul>

    <h2>Your Rights</h2>
    <p>
      You may access, update, or delete your personal information by visiting your account settings within the app. You may also contact us at <a href="mailto:developer@belivmart.com">developer@belivmart.com</a> for any privacy-related requests.
    </p>

    <h2>Developer and Contact Information</h2>
    <p>
      This policy is managed by <strong>Belivmart</strong>. If you have any questions about this policy, you can contact us at:
    </p>
    <p>
      Email: <a href="mailto:developer@belivmart.com">developer@belivmart.com</a><br/>
      Website: <a href="https://belivmart.com">belivmart.com</a>
    </p>
  </section>

  <footer className="privacy-footer">
    <p>© {new Date().getFullYear()} Belivmart. All rights reserved.</p>
  </footer>
</div>

  );
};

export default PrivacyPolicy;
